<div class="capture-details-container">
  <img src="assets/capture-details-component.png" alt="Capture Details"/>
  <h3><b>{{ headerText }}</b></h3>
  <mat-grid-list cols="1" rowHeight="75px">
    <mat-grid-tile>
      <button class="capture-button" mat-raised-button color="primary" (click)="onClickButton()">
        <mat-icon>add</mat-icon>
        {{ buttonText }}
      </button>
    </mat-grid-tile>
  </mat-grid-list>
  <p class="subtext m-5">{{ subtext }}</p>
</div>
